import { useQuery } from '@tanstack/react-query'
import api from '../utils/api'


export type AccessServiceType = { uuid: string; name: string; description?: string | null }

export type DescriptionMode = 'off' | 'optional' | 'required'

const DESCRIPTION_MODES: DescriptionMode[] = ['off', 'optional', 'required']


/**
 * Catálogo encendido y qué tanto se pide la descripción, a partir de los settings crudos de la
 * comunidad. Mismas reglas que la API (AccessAuthorization::serviceTypesEnabled / descriptionMode):
 * sin catálogo la descripción es obligatoria; con catálogo, opcional por omisión.
 */
export function serviceTypesConfig(settings: any): { catalogEnabled: boolean; descriptionMode: DescriptionMode } {
  const config = settings?.access_authorization ?? {}
  const catalogEnabled = !!config.service_types?.enabled

  if (!catalogEnabled) return { catalogEnabled, descriptionMode: 'required' }

  const mode = config.description
  return { catalogEnabled, descriptionMode: DESCRIPTION_MODES.includes(mode) ? mode : 'optional' }
}


/**
 * Catálogo de servicios permitidos en autorizaciones de acceso, para admin y vigilancia. El
 * residente no lo usa: lo recibe ya resuelto en su dashboard (`settings.access_authorization`).
 * La lista se trae aunque el catálogo esté apagado: la bandeja filtra por tipo el historial.
 */
export default function useAccessServiceTypes(communityId?: string, settings?: any) {
  const query = useQuery<AccessServiceType[]>({
    queryKey: ['access-service-types', communityId],
    queryFn: () => api.get(`/communities/${communityId}/access-service-types`).then(r => r.data),
    enabled: !!communityId,
  })

  return {
    ...serviceTypesConfig(settings),
    types: query.data ?? [],
    isLoading: query.isLoading,
  }
}
